export default {
	type: 'object',
	properties: {
		gameId: ['string', 'number'],
	},
	required: ['gameId'],
	additionalProperties: false,
}
